import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, createSlots as _createSlots, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "va-main" }
const _hoisted_2 = { class: "va-main-breadcrumb" }
const _hoisted_3 = { class: "va-main-body" }
const _hoisted_4 = { class: "va-main-body-search" }
const _hoisted_5 = { class: "va-main-body-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  title: "删除",
  style: {"margin-left":"5px","color":"palevioletred"}
}

import {EditOutlined, DeleteOutlined} from '@ant-design/icons-vue';
import {APIUri, del} from "@/api";
import VABreadcrumb from "../VABreadcrumb/VABreadcrumb"
import VASearch from "../VASearch/VASearch"
import VAFormDrawer from "../VAFormDrawer/VAFormDrawer"
import VACard from "../VACard/VACard"
import {ref} from "vue";
import propsOptions from './props'
import {useDrawer} from "./hooks";


export default /*@__PURE__*/_defineComponent({
  __name: 'VACardRest',
  props: propsOptions,
  setup(__props) {

const props = __props

const cardRef = ref({})
const {visible, data, clickAdd, clickUpdate, submit, title} = useDrawer(APIUri.HorusEye.Model.restful)

const onDelete = async (id: number) => {
  const res = await del(APIUri.HorusEye.Model.restful.delete, id)
  if (res.data.code === 0) {
    message.success(res.data.msg)
    onSearch()
  }
}

const onSearch = (params: any = {}) => {
  // 如果默认搜索和搜索都有query类型，则把query合并，避免冲突
  if ('query' in params && 'query' in props.searchDefaultParams) {
    params['query'] = [...params.query, ...props.searchDefaultParams['query']]
  }
  cardRef.value.reload({...props.searchDefaultParams, ...params})
}



return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(VABreadcrumb), {
        options: props.breadcrumbOptions
      }, null, 8, ["options"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(VASearch), {
          options: props.searchOptions,
          onOnSearch: onSearch
        }, null, 8, ["options"])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "va-card-hr" }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        (props.uris.create)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "va-rest-add-btn",
              onClick: _unref(clickAdd),
              type: "primary",
              size: "small",
              style: {"margin-right":"10px"}
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("添加 ")
              ])),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (props.uris.list)
          ? (_openBlock(), _createBlock(_unref(VACard), {
              key: 1,
              ref_key: "cardRef",
              ref: cardRef,
              uri: props.uris.list,
              options: props.cardOptions
            }, _createSlots({
              "va-card-action": _withCtx(({data}) => [
                _renderSlot(_ctx.$slots, "va-card-action", {}, () => [
                  (props.uris?.update)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (_unref(clickUpdate)(data)),
                        title: "修改",
                        style: {"margin-left":"20px"}
                      }, [
                        _createVNode(_unref(EditOutlined))
                      ], 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (props.uris?.delete)
                    ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 1,
                        title: `确定删除${data.name}?`,
                        "ok-text": "确定",
                        "cancel-text": "取消",
                        onConfirm: ($event: any) => (onDelete(data.id))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_7, [
                            _createVNode(_unref(DeleteOutlined))
                          ])
                        ]),
                        _: 2
                      }, 1032, ["title", "onConfirm"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, [
              (props.cardOptions.headSlot)
                ? {
                    name: "va-card-head",
                    fn: _withCtx(({data}) => [
                      _renderSlot(_ctx.$slots, "va-card-head", { data: data })
                    ]),
                    key: "0"
                  }
                : undefined,
              (props.cardOptions.iconSlot)
                ? {
                    name: "va-card-icon",
                    fn: _withCtx(({data}) => [
                      _renderSlot(_ctx.$slots, "va-card-icon", { data: data })
                    ]),
                    key: "1"
                  }
                : undefined,
              (props.cardOptions.contentSlot)
                ? {
                    name: "va-card-content",
                    fn: _withCtx(({data}) => [
                      _renderSlot(_ctx.$slots, "va-card-content", { data: data })
                    ]),
                    key: "2"
                  }
                : undefined
            ]), 1032, ["uri", "options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(VAFormDrawer), {
      title: _unref(title),
      visible: _unref(visible),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      data: _unref(data),
      options: props.formOptions,
      onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_unref(submit)(onSearch))),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
    }, null, 8, ["title", "visible", "data", "options"])
  ]))
}
}

})